import { createRequestHelper } from '@utils/swr'
import { type CampaignActivityInfoResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['getExhibitorSettings'], CampaignActivityInfoResponse, string | null>({
  client: 'fortune',
  key: code => code ? `/campaigns/${code}/activity_info` : null,
  isImmutable: true,
})

export const useApiCampaignActivityInfoImmutable = useRequest
